module.exports = __webpack_public_path__ + "img/jiance_tw.02446184.jpg";